import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

import type { OverrideStatusEnum } from 'src/common/external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export function TripStatusBadge({
  status,
  onDelete,
}: {
  status: OverrideStatusEnum | undefined;
  onDelete?: () => void;
}) {
  const role = useUserRoles();

  let color = '';

  switch (status) {
    case 'canceled':
    case 'rejected':
      color = 'red';
      break;
    case 'transporting':
      color = 'yellow';
      break;
    case 'pending':
      color = 'orange';
      break;
    case 'completed':
      color = 'green';
      break;
    case 'en route':
    default:
      color = 'primary';
  }

  const tripStatus =
    role.isRideOrderingPortalUser && status === 'pending' ? 'accepted' : status;

  return (
    <Badge
      label={tripStatus || 'unknown'}
      color={color}
      onClose={onDelete}
      closeable={!!onDelete}
    />
  );
}
